import React, { useEffect, useState } from "react";
import { Button, Typography, Chip, Divider, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { toast } from "react-toastify";
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import InfoIcon from '@mui/icons-material/Info';
import PersonIcon from '@mui/icons-material/Person';
import CommentIcon from '@mui/icons-material/Comment';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import "../styles/pages/consultation_for.scss";

const Consultationfor = () => {
    const [paymentsData, setPaymentsData] = useState([]);
    const [consultation, setConsultations] = useState();
    const navigate = useNavigate();
    const { id } = useParams();

    const fetchConsultations = async () => {
        try {
            const response = await instance.get(`/Consultation/getConsultationsById/${id}`);
            setConsultations(response.data.data.response);
            setPaymentsData(response.data.data.payments);
        } catch (error) {
            console.log("error", error);
        }
    }

    useEffect(() => {
        fetchConsultations();
    }, []);

    const getStatusColor = (status) => {
        const statusColors = {
            "Done": { bg: "#E1FCEF", color: "#14804A" },
            "Pending": { bg: "#FCF2E6", color: "#AA5B00" },
            "Booked": { bg: "#EBF0FA", color: "#2264E5" },
            "In Progress": { bg: "#F1FDFF", color: "#3CC3DF" },
            default: { bg: "#E9EDF5", color: "#333" },
        };
        return statusColors[status] || statusColors.default;
    };


    // console.log(consultation)
    return (
        <div className="consultation-container">
            {/* Header Section */}
            <div className="consultation-header">

                <div className="header-info">
                    <Typography className="page-title">Pay & Approve</Typography>
                    <Typography className="consultation-subtitle">
                        Consultation #{consultation?.consultation_id || " ----"}
                    </Typography>
                </div>

                <Button
                    className="back-button"
                    onClick={() => navigate("/profile/myinteraction")}
                    startIcon={<KeyboardBackspaceIcon />}
                >
                    Back
                </Button>

            </div>

            <div className="content-wrapper">
                {/* Payment Details Section */}
                <div className="">
                    {consultation?.consultation_type === "In Person" && (
                        <div className="consultation-section">
                            <div className="section-header">
                                <div className="section_paynow">
                                    <PaymentIcon className="section-icon" />
                                    <Typography className="section-title">Payment Details</Typography>
                                </div>

                                {paymentsData && paymentsData?.status != "Done" && paymentsData?.status != "Failed" && (
                                    <div className="pay-button-container">
                                        <Button
                                            startIcon={<PaymentIcon />}
                                            onClick={() => {
                                                if (paymentsData?.payment_link) {
                                                    window.open(paymentsData?.payment_link, "_blank");
                                                } else {
                                                    toast.error("Payment Unavailable");
                                                }
                                            }}
                                            disabled={!paymentsData?.payment_link}
                                        >
                                            {paymentsData?.payment_link ? "Pay Now" : "Unavailable"}
                                        </Button>
                                    </div>
                                )}
                            </div>

                            <div className="consultation-grid">
                                <div className="consultation-item">
                                    <span className="item-label">
                                        <ReceiptIcon className="item-icon" />
                                        <span >Transaction ID</span>
                                    </span>
                                    <span className="item-value">
                                        {paymentsData?.merchant_Transaction_Id || "---"}
                                    </span>
                                </div>

                                <div className="consultation-item">
                                    <span className="item-label">
                                        <CalendarTodayIcon className="item-icon" />
                                        Payment Date
                                    </span>
                                    <span className="item-value">
                                        {paymentsData?.createdAt
                                            ? new Date(paymentsData.createdAt).toLocaleDateString("en-GB")
                                            : "---"}
                                    </span>
                                </div>

                                <div className="consultation-item">
                                    <span className="item-label">
                                        <InfoIcon className="item-icon" />
                                        <span>Payment Status</span>
                                    </span>
                                    <span className="item-value">
                                        <Chip
                                            label={paymentsData?.for === "Order"
                                                ? paymentsData?.order_id?.payment_status
                                                : paymentsData?.status}
                                            size="small"
                                            className="status-chip"
                                            style={{
                                                backgroundColor: getStatusColor(
                                                    paymentsData?.for === "Order"
                                                        ? paymentsData?.order_id?.payment_status
                                                        : paymentsData?.status
                                                ).bg,
                                                color: getStatusColor(
                                                    paymentsData?.for === "Order"
                                                        ? paymentsData?.order_id?.payment_status
                                                        : paymentsData?.status
                                                ).color,
                                                fontWeight: 600,
                                                fontSize: '10px'
                                            }}
                                        />
                                    </span>
                                </div>

                                <div className="consultation-item highlight">
                                    <span className="item-label">
                                        Payment Amount
                                    </span>
                                    <span className="item-value">
                                        ₹{paymentsData?.for === "Order"
                                            ? paymentsData?.order_id?.payment_amount
                                            : paymentsData?.amount}
                                    </span>
                                </div>

                                {paymentsData?.for === "Order" && (
                                    <>
                                        <div className="consultation-item">
                                            <span className="item-label">Amount Paid</span>
                                            <span className="item-value">
                                                ₹{paymentsData?.order_id?.paid_amount}
                                            </span>
                                        </div>

                                        <div className="consultation-item">
                                            <span className="item-label">Pending Amount</span>
                                            <span className="item-value amount pending">
                                                ₹{paymentsData?.order_id?.pending_amount}
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>


                        </div>
                    )}

                    <div className="consultation-section">
                        {/* Consultation Details Section */}
                        <div className="section-header">
                            <div className="section_paynow">
                                <InfoIcon className="section-icon" />
                                <Typography className="section-title">
                                    {consultation?.for === "Order"
                                        ? "Order Information"
                                        : "Consultation Information"}
                                </Typography>
                            </div>
                        </div>

                        <div className="consultation-grid">
                            <div className="consultation-item">
                                <span className="item-label">
                                    {consultation?.for === "Order" ? "Order ID" : "Order ID"}
                                </span>
                                <span
                                    className="item-value clickable"
                                    onClick={() => navigate(`/profile/orders-details/${consultation?.order_id?._id}`)}
                                >
                                    {consultation?.for === "Order"
                                        ? paymentsData?.order_id?.order_id
                                        : consultation?.order_id?.order_id}
                                </span>
                            </div>

                            <div className="consultation-item">
                                <span className="item-label">
                                    {consultation?.for === "Order"
                                        ? "Customer Name"
                                        : "Consultation Type"}
                                </span>
                                <span className="item-value">
                                    {consultation?.for === "Order"
                                        ? paymentsData?.order_id?.address?.name
                                        : consultation?.consultation_type}
                                </span>
                            </div>

                            <div className="consultation-item">
                                <span className="item-label">Consultation ID</span>
                                <span className="item-value">
                                    {consultation?.for === "Order"
                                        ? paymentsData?.order_id?.order_id
                                        : consultation?.consultation_id}
                                </span>
                            </div>

                            <div className="consultation-item">
                                <span className="item-label">
                                    {consultation?.for === "Order"
                                        ? "Order Status"
                                        : "Consultation Status"}
                                </span>
                                <span className="item-value">
                                    <Chip
                                        label={consultation?.for === "Order"
                                            ? [
                                                "Uassigned",
                                                "Assigned",
                                                "In Payment",
                                                "Acquisition",
                                            ].includes(paymentsData?.order_id?.status)
                                                ? "In Progress"
                                                : paymentsData?.order_id?.payment_status
                                            : ["Uassigned", "Assigned", "In Payment"].includes(
                                                consultation?.status
                                            )
                                                ? "Booked"
                                                : consultation?.status}
                                        size="small"
                                        className="status-chip"
                                        style={{
                                            backgroundColor: getStatusColor("In Progress").bg,
                                            color: getStatusColor("In Progress").color,
                                            fontWeight: 600,
                                            fontSize: '10px'
                                        }}
                                    />
                                </span>
                            </div>

                            <div className="consultation-item">
                                <span className="item-label">
                                    {consultation?.for === "Order"
                                        ? "Ordered Date"
                                        : "Date of consultation"}
                                </span>
                                <span className="item-value">
                                    {
                                        paymentsData?.for === "Order"
                                            ? paymentsData?.order_id?.createdAt
                                                ? new Date(paymentsData.order_id.createdAt).toLocaleDateString("en-IN", {
                                                    timeZone: "Asia/Kolkata",
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                })
                                                : "---"
                                            : consultation?.consultation_date
                                                ? new Date(consultation.consultation_date).toLocaleDateString("en-IN", {
                                                    timeZone: "Asia/Kolkata",
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                })
                                                : "---"
                                    }
                                </span>
                            </div>

                            <div className="consultation-item">
                                <span className="item-label">Requirements</span>
                                <span className="item-value">
                                    {consultation?.reason || "---"}
                                </span>
                            </div>
                        </div>

                        {/* Admin Comments Section */}
                        {consultation?.comments && consultation.comments.length > 0 && (
                            <div className="comments-section">
                                <div className="comments-header">
                                    <CommentIcon className="comments-icon" />
                                    <Typography className="comments-title">Admin Comments</Typography>
                                </div>
                                <div className="comments-list">
                                    {consultation.comments.map((data, index) => (
                                        <div key={index} className="comment-item">
                                            <PersonIcon className="comment-icon" />
                                            <span className="comment-text">{data}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Consultationfor;
